import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, switchMap, timer } from 'rxjs';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { LogService } from 'src/app/services/log.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../models/Constants';
import * as platformClient from 'purecloud-platform-client-v2';
import * as _ from 'lodash';
import { ApiService } from '../../services/api.service';
import { AwsSqsService } from '../../services/aws-sqs.service';
import { SpeedTestService } from 'ng-speed-test';
import { DashboardBusinessLogicService } from 'src/app/services/dashboard-business-logic.service';
import { MatDialog } from '@angular/material/dialog';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { LogoutBusinessLogicService } from 'src/app/services/logout-business-logic.service';


@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  loading$ = this.rootScope.loading$;
  isAuthorized = false;
  title = 'Care Portal';
  public alertConfig = {
    type: 'error',
  };
  displayAlert: boolean = false;
  subscription: Subscription;
  networkSpeedSubscription!: Subscription;
  showUserProfileCard: boolean = false;
  inboundMsg: string = Constants.INBOUND_CALL_ACCESS_ERRORMSG;
  breadcrumbItems: Array<any> = [
    {
      name: 'Customer Account',
      url: '/customer-account',
      selected: false,
      id: 1,
    },
    {
      name: 'Interaction History',
      url: '/interaction-history',
      selected: true,
      id: 2,
    },
    { name: 'Invoicing', url: '/invoicing', selected: true, id: 3 },
    { name: 'Current', url: '/current', selected: false, id: 4 },
  ];
  loadUI: boolean = true;
  currentActiveTabId: any;
  isSSODuplicate: boolean = false;
  loaderType = Constants.LOADER_TYPE.FULL_SCREEN;

  constructor(
    private genesysCloudService: GenesysCloudService,
    private route: ActivatedRoute,
    private apiService: ApiService,
    public rootScope: RootScopeService,
    public router: Router,
    private logger: LogService,
    private awssqsservice: AwsSqsService,
    private speedTestService: SpeedTestService,
    public dashboardService: DashboardBusinessLogicService,
    public dialog: MatDialog, public idle: Idle, public logOutService: LogoutBusinessLogicService,
  ) {
    this.subscription = this.genesysCloudService
      .onMessage()
      .subscribe((message) => {
        if (message) {
          this.connectToGenesys();
        }
      });
    this.updateIdleStatus();

    /*** If user prefers to go with new session on, previous opened tab should redirect to
     * chrome default page as previous sessionId is expired 
  
    window.addEventListener('storage', (event) => {
      console.log('event', event);
      if (event.key == 'sessionId' && event.oldValue == null) {
        window.open('http://www.google.com', '_self');
      }
    });*/
  }



  ngOnInit() {

    this.setSessionId();
    /* istanbul ignore next */
    this.logger.log(platformClient);
    
    // this.genesysStatus();

    // this.rootScope.createForm();
    this.networkSpeedSubscription = this.rootScope.timeThreshold
      .pipe(switchMap((period: number) => timer(0, period)))
      .subscribe((res) => {
        this.getNetworkOnline();
        this.getSpeed();
      });
  }

  setSessionId() {

    if (!this.rootScope.sessionId) {
      this.rootScope.sessionId = localStorage.getItem('sessionId');
    }

    if (!this.rootScope.emailId) {
      this.rootScope.emailId = localStorage.getItem('emailId');
    }

    if (!this.rootScope.firstName) {
      this.rootScope.firstName = localStorage.getItem('firstName');
    }

    if (!this.rootScope.lastName) {
      this.rootScope.lastName = localStorage.getItem('lastName');
    }

    if (!this.rootScope.lanId) {
      this.rootScope.lanId = localStorage.getItem('lanId');
    }

    if (!this.rootScope.browserSessionStartTimestamp) {
      this.rootScope.browserSessionStartTimestamp = sessionStorage.getItem('browserSessionStartTimestamp') || new Date().toISOString();
    }

    this.rootScope.createNameForUserProfile(
      this.rootScope.firstName,
      this.rootScope.lastName,
      this.rootScope.lanId, this.rootScope.browserSessionStartTimestamp
    );
    this.rootScope.setUserAndEmailInStorage();
    this.checkMultiSessionScenario();
  }



  /**
   * Below method fetches the application
   * related configuration data and
   * store globaly in appConfigObj variable
   * @author :Pooja Gupta
   */
  getApplicationConfiguration() {
    let that = this;
    this.apiService.getApplicationConfiguration().subscribe({
      next: (data) => {
        /* istanbul ignore next */
        if (data) {
          console.log('Application configuration data = ', data);
          that.rootScope.appConfigObj = data['data'];
          that.awssqsservice.getAWSConfigObj();
          that.rootScope.createCCTConfigObj();
          that.awssqsservice.loadAWSconfigForAngularLogs();
          that.rootScope.getNetworkConfigValues();
          that.appIdleTimeoutSetUp();
          /* istanbul ignore next */
          if (that.rootScope.isAuthenticate && this.rootScope.loadUI) {
            that.apiService.validateTimeStampToken();
            that.rootScope.setTimeOutDetails({ 'watch': true, 'stop': false });
          }
        }
      },
      error: (error) => {
        this.logger.log(error);
        that.appIdleTimeoutSetUp();
      },
    });
  }

  /**
   * Below method main focus on handling of
   * various ways of launchig app and in valid and invalid(duplicate Session) Scenario
   * @author :Pooja Gupta
   */

  checkMultiSessionScenario() {
    // console.log(
    //   'Method checkMultiSessionScenario called ,isDuplicateSession =',
    //   this.rootScope.isDuplicateSession +
    //   'manual login ' +
    //   this.rootScope.launchAppFromManualLogin
    // );

    /*** Case 1:Launch of application via SSO  ****/
    /* istanbul ignore next */
    if (this.rootScope.launchAppBySSO) {
      this.loadApp();
      this.rootScope.launchAppBySSO = false;
    } else if (this.rootScope.isSSODuplicate) {
      /***Launch app via SSO but its duplicate *****/
      this.validateAppLoad();
    } else if (this.rootScope.launchAppFromManualLogin) {
      /*** Case 2:Launch of application via Manual Login Page and its found to be duplicate from backend ****/
      if (this.rootScope.isDuplicateSession == 'true') {
        this.validateAppLoad();
      } else {
        this.loadApp();
      }
    } else {
      /*** Case 3 & 4 :Launch of application via click on open duplicate tab OR  bookmark app url OR directly loading app dashboard URL */
      this.apiService.getInfoAbtDuplicateSession().subscribe({
        next: (data2) => {
          //  console.log('datat', data2);
          let data = data2['data'];
          if (data['isDuplicate'] == 'true') {
            /********Case 5 : User refreshes the application on active as well as on not active opened tab  ****/
            if (sessionStorage.getItem('isActiveTabRefreshed') == 'true' && sessionStorage.getItem('ALISRegistration') == 'true') {
              if (this.rootScope.sessionId == data['jSessionId']) {
                this.rootScope._isAuthenticated.next(true);
                this.loadApp();
                sessionStorage.setItem('isActiveTabRefreshed', 'false');
                sessionStorage.setItem('ALISRegistration', 'false');//only for ALISRegistration navigation
              } else {
                /** Here basically if user has changed the session in another browser  and user comes again to already opened previos session in another browser **/
                this.validateAppLoad();
              }
            } else {
              this.validateAppLoad();
            }
          } else {
            this.loadApp();
          }
        },
        error: (error) => {

          // console.log(
          //   'Error in getting response of DUplicate session from backend',
          //   error
          // );
          this.rootScope.enableAlerts(
            Constants.ERROR,
            Constants.API_FAILURE_MSG
          );
          this.router.navigate(['/login']);
        },
      });
    }
  }

  getAppData() {
    this.getApplicationConfiguration();
    this.genesysCloudService.customerService.getClientDetails();
    this.apiService.customerAccountApis();
  }

  loadApp() {
    this.getAppData();
    this.rootScope.loadUI = true;
    this.genesysStatus();
    this.onLoadTbaGuiReg();
    this.apiService.getRestoreAccountDetails();
  }

  validateAppLoad() {
    this.showPopup();
    this.rootScope.loadUI = false;
    this.getAppData();
  }

  /**Below Method Check if the user is Connected to Genesys Clour or in Live Call */
  /* istanbul ignore next */
  genesysStatus() {
    if (sessionStorage.getItem('connectToGenesys') == 'true') {
      var ALIS_region: any = sessionStorage.getItem('ALIS_region');
      this.genesysCloudService.environment = ALIS_region;
      this.connectToGenesys();
      sessionStorage.removeItem('isLiveCall');
    }
    // if (sessionStorage.getItem('isLiveCall') == 'true')
    //   this.genesysCloudService.genesysNotifyCallOrChat(true);
  }

  /**Below method is used to connect the Care Portal Application with the Genesys Cloud
   * which take the user on Genesys Login Page by redirecting it. */
  /* istanbul ignore next */
  connectToGenesys() {
    // this.genesysCloudService.isAuthorized.subscribe((isAuthorized) => {
    //   this.isAuthorized = isAuthorized;
    // });
    // Get query parameters for 'environment' and 'language'
    this.route.queryParams.subscribe((params) => {
      const language = params['language'];
      const environment = params['environment'];
      this.genesysCloudService.setLanguage(language);
      this.genesysCloudService.setEnvironment(environment);

      this.rootScope.alisRegistrationLoaderTimeoutId = setTimeout(() => {
        this.rootScope.showAlisRegistrationLoaderMsg = true;
      }, 1 * this.rootScope.showLoaderMsgThreshold * 1000);

      this.rootScope.alisRegistrationLoader = true;
      this.genesysCloudService.initialize().subscribe({
        next: (res: any) => {
          clearTimeout(this.rootScope.alisRegistrationLoaderTimeoutId);
          this.rootScope.alisRegistrationLoader = false;
          this.rootScope.showAlisRegistrationLoaderMsg = false;
          this.rootScope.ALISRegistrationCardMsgAfterSessionPopUp = false;
          this.logger.info('Succesfully logged in gensys.');
          this.dashboardService.savePreferenceValue().subscribe({
            next: (data: any) => {
              if (data?.httpStatusCode == 200) {
                //  console.log('save preference value sucussfully in database', data);
              }
            },
            error: (error) => {
              // console.log('Error in saving the preference value in database', error);
              this.rootScope.enableAlerts(Constants.ERROR, Constants.API_FAILURE_MSG);
            },
          });

          this.getPresenceStatus();
          this.genesysCloudService.genesysCloudNotificationSetup();
          this.rootScope.setIsGensysLoggedIn(true);
          this.rootScope.ALISRegistrationSuccessChangeOrg = true;
          this.rootScope.ALISRegistrationCardSuccess = true;
          this.rootScope.ALISRegistrationCardError = false;
          //Below code is used to display one alert at a time.
          this.rootScope.ALISChangeOrgInfoMsg = false;
        },
        error: (error) => {
          clearTimeout(this.rootScope.alisRegistrationLoaderTimeoutId);
          this.rootScope.alisRegistrationLoader = false;
          this.rootScope.showAlisRegistrationLoaderMsg = false;
          this.rootScope.ALISRegistrationCardError = true;
        },
      });
    });

    if (!localStorage.getItem('userId')) {
      this.getUserId();
    }
  }

  userId: any = '';
  getUserId() {
    this.genesysCloudService.getUserMe().subscribe((userDetails) => {
      this.userId = userDetails.id;
      localStorage.setItem('userId', this.userId);
      this.genesysCloudService.genesysCloudNotificationSetup();
    });
  }

  /* istanbul ignore next */
  /**Below method get the User details of ALIS from which we get the presence status of ALIS */
  getPresenceStatus() {
    this.genesysCloudService.getUserMe().subscribe({
      next: (res) => {
        let presence: any = res?.presence?.presenceDefinition?.systemPresence;
        this.genesysCloudService._presenceStatus.next(presence);
      },
      error: (error) => { },
    });
  }

  /**istanbul ignore next */
  // onBreadcrumbSelect(evnt) {
  //   // console.log('Method onBreadcrumbSelect called ', evnt);
  //   if (evnt.detail) {
  //     this.breadcrumbItems = _.filter(
  //       this.breadcrumbItems,
  //       function (currentObject) {
  //         return currentObject.id !== evnt.detail.id;
  //       }
  //     );
  //   }
  // }

  /***** Below method is called whenever user closes the tab /browser window or refreh the browsser
   
    * Used for handling a sceanrio where user refreshes active tab at that time prompt should not appear
    * as its not case of multiple session .
    *  ******/

  @HostListener('window:beforeunload', ['$event'])
  /**instanbul ignore next */
  beforeunloadHandler(event) {
    if (this.rootScope.loadUI) {
      sessionStorage.setItem('isActiveTabRefreshed', 'true');
    } else {
      sessionStorage.setItem('isActiveTabRefreshed', 'false');
    }

  }

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // console.log(event);
    let x = event?.keyCode;
    if (x === 27) {
      // console.log('Escape!');
    }
  }
  // Common Method here
  /* istanbul ignore next */
  showPopup() {
    this.rootScope.openDialog({
      title: '',
      subheading: '',
      message: Constants.MULTI_SESSION_DIALOG_MSG,
      firstbutton: Constants.buttonEnum.opneNewSession,
      secondbutton: Constants.buttonEnum.restoreLastSession,
      crossIcon: false,
      comingFrom: 'main',
      additionalClass: 'multi-session-modal',
    });

    this.apiService.appSessionTimer();
  }



  /**Below method check if the network is available and return the boolean value
   *  that is internet connection is active or inactive. */
  getNetworkOnline() {
    this.speedTestService.isOnline().subscribe((isOnline) => {
      if (isOnline === true) {
        this.rootScope.isNetworkOnline = true;
      } else {
        this.rootScope.isNetworkOnline = false;
      }
    });
  }

  /* istanbul ignore next */
  /**Below method get the current internet speed in Mbps (megabits per second).*/
  getSpeed() {
    this.speedTestService
      .getMbps({
        iterations: 10,
        file: {
          path: '../assets/images/network-speed-tester.png',
          shouldBustCache: true,
          size: 30144,
        },
      })
      .subscribe((speed) => {
        this.rootScope.speed.next(Math.round(speed));
        // console.log(
        //   'Your speed is ' +
        //   speed +
        //   '>>>' +
        //   ', network online :' +
        //   this.rootScope.isNetworkOnline
        // );
        return speed;
      });
  }


  /**
   * Below method  checks if the 'TBAGUIRegistrationnAuthorized' item is present in the localStorage and if the 'isConnected' item is true.
   *If both conditions are met, it sets the 'TBAGUIRegistrationnAuthorized' flag to true and starts the TBA connectivity interval through the dashboard service.
  */
 /* istanbul ignore next */
  onLoadTbaGuiReg() {
    let isPresent = localStorage.getItem('TBAGUIRegistrationnAuthorized');
    let isConnected = localStorage.getItem('isConnected');
    if (isPresent && isConnected) {
      this.rootScope.TBAGUIRegistrationnAuthorized = true;
      this.dashboardService.startTbaConnectivityInterval();
    }
  }

  /**
  * Below method handles triggering idel timmer to handle inactivity in application level
  * failure or success.
  * If user reach 29.30 secconds needs to prompt alert msg and will be
  * when user reach 30 mints redirected to logoff page and CLOSE the model popup
  */

  appIdleTimeoutSetUp() {
    this.apiService.globalIconIdUpdate(Math.floor(Math.random() * Constants.IndexId));
    this.idle.stop();
    // sets an idle timeout of 29.30MIN, for purposes.
    this.idle.setIdle(this.rootScope.CCTConfigs.APP_IDLE_TIME);
    // sets a timeout period of 30 seconds. after 29.30 MIN of inactivity, the user will be considered timed out.
    this.idle.setTimeout(this.rootScope.CCTConfigs.APP_TIMEOUT);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onTimeoutWarning.subscribe((secondsLeft: number) => {
      /* istanbul ignore next */
      if (secondsLeft == this.rootScope.CCTConfigs.APP_TIMEOUT && !this.dialog.getDialogById('timeOutPopUp')) {
        this.rootScope.clearInterval = false;
        this.apiService.globalIconUpdate(true);
        this.appTimeOutAlertTimer();
      }
    });

    // this.idle.onIdleStart.subscribe((secondsLeft: any) => {

    // });

    this.idle.onTimeout.subscribe(() => {
      setTimeout(() => {
        if (this.rootScope.isAuthenticate && !this.rootScope.clearInterval) {
          clearInterval(this.rootScope.timemoutPopUpInteraval);
          this.logOutService.appLogOut(this);
        }
      }, 500);

    });
  }

  /**
    * Below method handles dynmic timer seconds running a counter down secs and
    * stop timer intervel once it reaches zero sec
    * 
    */
  appTimeOutAlertTimer() {

    if (location?.pathname?.includes(Constants.pathname)) this.idle.stop();
    else {
      let timeLeft = this.rootScope.CCTConfigs.APP_TIMEOUT;
      this.rootScope.timespan = this.rootScope.CCTConfigs.APP_TIMEOUT + ' seconds';
      /* istanbul ignore next */
      this.rootScope.timemoutPopUpInteraval = setInterval(() => {
        this.rootScope.timespan = timeLeft?.toString() + ' seconds';
        if (this.rootScope.clearInterval) {
          clearInterval(this.rootScope.timemoutPopUpInteraval);
          this.rootScope.clearInterval = false;
          this.apiService.globalIconUpdate();
        }
        else if (timeLeft > 0) {
          timeLeft--;
        } else {
          clearInterval(this.rootScope.timemoutPopUpInteraval);
          /* istanbul ignore next */
          this.rootScope.clearInterval = true;
          /* istanbul ignore next */
          this.logOutService.appLogOut(this);
        }
      }, 1000);
      this.rootScope.openTimeoutDialog();
    }
  }

  /**
   * update idle timer status stop and start
   */
  updateIdleStatus() {
    this.rootScope.getTimeOutDetails().subscribe((data: any) => {
      if (data?.stop)
        this.idle.stop();
      else if (data?.watch) {
        this.idle.setIdle(this.rootScope.CCTConfigs.APP_IDLE_TIME);
        this.idle.setTimeout(this.rootScope.CCTConfigs.APP_TIMEOUT);
        this.idle.watch();
      }
    });
  }



  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.networkSpeedSubscription.unsubscribe();
    clearTimeout(this.rootScope.alisRegistrationLoaderTimeoutId);
    this.rootScope.showAlisRegistrationLoaderMsg = false;
    this.rootScope.alisRegistrationLoader = false;
    this.rootScope.browserSubscription?.unsubscribe();
    this.rootScope.patchGENAttribute.unsubscribe();
    this.dialog.closeAll();
    if (this.rootScope.GenesysPureCloud) clearInterval(this.rootScope.GenesysPureCloud);
  }

}

